module.exports = __webpack_public_path__ + "img/9.1fece051.jpg";